import { FiPhone, FiMail, FiMapPin } from 'react-icons/fi';
import { motion } from 'framer-motion';
import { useGetUserData } from '../../hooks/useGetUserData';
import { useDoctorQuery } from '../../hooks/useDoctorQuery';
import { useParams } from 'react-router-dom';
import { useLanguage } from '../../context/LanguageContext';
import { ContactForm } from '../ContactForm/ContactForm';
import { MapIcon } from 'lucide-react';
import { FaMap } from 'react-icons/fa6';
import { CiLocationArrow1 } from 'react-icons/ci';
import { RiMapPinLine } from 'react-icons/ri';
import { Form, Select } from 'antd';

export default function ContactUs() {
    const { slug } = useParams();
    const { data: doctor } = useDoctorQuery();
    const { t } = useLanguage();

    const contactInfo = {
        phone: '+1 (555) 123-4567',
        email: 'info@healthcare.com',
        address: '123 Wellness Blvd, Healthy City, HC 12345',
        mapEmbedUrl:
            'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3153.0191387827946!2d-122.41941568468142!3d37.774929279759065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x8085809cabcdf1a9%3A0x7e4dfcd12e6af76!2sSan%20Francisco%20City%20Hall!5e0!3m2!1sen!2sus!4v1695667303275!5m2!1sen!2sus',
    };

    const fadeInUp = {
        hidden: { opacity: 0, y: 30 },
        visible: (i = 1) => ({
            opacity: 1,
            y: 0,
            transition: {
                delay: i * 0.3,
                duration: 0.6,
                ease: 'easeOut',
            },
        }),
    };

    if (doctor?.isLocked) {
        return null
    }

    return (
        <section className="relative mx-auto px-4 sm:px-6 lg:px-8 py-16 bg-page overflow-hidden">
            {/* Background Decorative Element */}
            <div className="absolute inset-0 bg-gradient-to-r from-primary/10 to-transparent pointer-events-none" />
            <div className="text-center mb-14">
                <motion.h2
                    className="text-4xl font-bold text-textPrimary tracking-tight"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={0}
                >
                    {t('contact.getInTouch')}
                </motion.h2>
                <motion.p
                    className="mt-3 text-textPrimary/70 max-w-2xl mx-auto"
                    initial="hidden"
                    animate="visible"
                    variants={fadeInUp}
                    custom={0.2}
                >
                    {t('contact.description')}
                </motion.p>
            </div>

            <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 max-w-7xl mx-auto">
                {/* Contact Info */}
                <div className="space-y-6 w-full">
                    {[
                        {
                            icon: <FiPhone className="text-primary mx-2.5 text-2xl" />,
                            title: t('contact.phone'),
                            content: (
                                <a
                                    href={`tel:${doctor?.phoneNumber}`}
                                    className="text-primary text-lg font-medium"
                                >
                                    {doctor?.phoneNumber}
                                </a>
                            ),
                        },
                        {
                            icon: <FiMail className="text-primary mx-2.5 text-2xl" />,
                            title: t('contact.email'),
                            content: (
                                <a
                                    href={`mailto:${doctor?.email}`}
                                    className="text-primary text-lg font-medium"
                                >
                                    {doctor?.email}
                                </a>
                            ),
                        },


                    ].filter(Boolean).map((item, index) => (
                        <motion.div
                            key={index}
                            className="flex w-full items-center space-x-4 p-4 bg-cardColor rounded-xl shadow-md"
                            initial="hidden"
                            animate="visible"
                            variants={fadeInUp}
                            custom={index + 1}
                        >
                            {item.icon}
                            <div>
                                <h3 className="text-xl font-semibold text-textPrimary mb-1">{item.title}</h3>
                                {item.content}
                            </div>
                        </motion.div>
                    ))}
                    <motion.div
                        className="flex flex-col space-x-4 p-4 bg-cardColor rounded-xl shadow-md"
                        initial="hidden"
                        animate="visible"
                        variants={fadeInUp}
                    >
                         <div className='flex justify-between items-center '>
                             <h3 className="text-xl font-semibold text-textPrimary mb-1 flex items-center gap-6 ps-3"><RiMapPinLine className="text-2xl" /> {t('contact.address')}</h3>

                                {/* <Form.Item
                                    className="w-32 p-0 m-0"
                                >
                                    <Select
                                        placeholder={t("contact.selectAddress")}
                                        className=" [&_.ant-select-selector]:border-primary w-20 border h-7 rounded-md  border-primary border-1"
                                        options={[
                                            { value: "Maintenance", label: t("services.maintenance") },
                                            { value: "Electrical", label: t("services.electrical") },
                                            { value: "Logistics", label: t("services.logistics") },
                                        ]}
                                    />
                                </Form.Item> */}
                            </div>

                        <address className="not-italic text-lg text-textPrimary ps-11">
                           
                                <span>

                                    {doctor?.clinics[0]?.name}
                                </span>
                            <motion.div
                                className="rounded-xl w-full overflow-hidden mt-2"
                                initial={{ opacity: 0, scale: 0.95 }}
                                animate={{ opacity: 1, scale: 1 }}
                                transition={{ delay: 0.9, duration: 0.7, ease: 'easeOut' }}
                            >
                                <iframe
                                    title={t('contact.locationMap')}
                                    src={contactInfo.mapEmbedUrl}
                                    className="w-[600px] h-[230px] rounded-xl"

                                    style={{ border: 0 }}
                                    allowFullScreen=""
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade"
                                />
                            </motion.div>
                        </address>
                    </motion.div>
                </div>

                <ContactForm />

            </div>

        </section>
    );
}